import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
import { SoilBand } from './ui/SoilBand';
export function UrgencySection() {
  return <section className="bg-field-deep text-center text-cream" aria-label="Oferta por tiempo limitado" data-id="element-284" data-mp="36azequkbcbdk">
      <SoilBand data-id="element-285" data-mp="31ifsl97k87x5" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-286" data-mp="31hxyoj8de5se">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-gold" data-id="element-287" data-mp="3g7lyth4teyej">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-288" data-mp="3b7zcmi70e7tl" /> Precio de lanzamiento · cierra en
        </p>
        <Countdown light className="mt-6 scale-110" data-id="element-289" data-mp="3p7iggyssex03" />
        <h2 className="mt-8 text-2xl font-extrabold sm:text-3xl" data-id="element-290" data-mp="3l7hv0u79tljj">Tu ciclo lectivo puede estar listo hoy</h2>
        <p className="mt-3 font-bold text-field-light" data-id="element-291" data-mp="1uu94n0crqzeo">Después sube. No vuelve al precio de lanzamiento.</p>
        <div className="mx-auto mt-6 max-w-xl rounded-lg border border-field-soft bg-field/70 p-4 text-sm" data-id="element-292" data-mp="1qtz1rwk9wp41">
          <p className="font-bold" data-id="element-293" data-mp="2supm62cpnxya">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-gold" data-id="element-294" data-mp="2srl9egl6jtw0" />
            Cupos al precio de lanzamiento: quedan pocos
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-black/30" data-id="element-295" data-mp="32qsvbs5zcwuq">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '71%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-gold" data-id="element-296" data-mp="37j2gyw02bar7" />
          </div>
          <p className="mt-1 text-right text-xs text-field-light" data-id="element-297" data-mp="3ljddaek55hjr">71% tomados</p>
        </div>
      </div>
      <SoilBand data-id="element-298" data-mp="3qg3s6yk7m73l" />
    </section>;
}